var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.32129 6V3C7.32129 2.73478 7.42665 2.48043 7.61418 2.29289C7.80172 2.10536 8.05607 2 8.32129 2H20.3213C20.5865 2 20.8409 2.10536 21.0284 2.29289C21.2159 2.48043 21.3213 2.73478 21.3213 3V17C21.3213 17.2652 21.2159 17.5196 21.0284 17.7071C20.8409 17.8946 20.5865 18 20.3213 18H17.3213V21C17.3213 21.552 16.8713 22 16.3143 22H4.32829C4.19642 22.0008 4.06569 21.9755 3.94361 21.9256C3.82154 21.8757 3.71052 21.8022 3.61695 21.7093C3.52337 21.6164 3.44908 21.5059 3.39834 21.3841C3.3476 21.2624 3.32142 21.1319 3.32129 21L3.32429 7C3.32429 6.448 3.77429 6 4.33129 6H7.32129ZM5.32429 8L5.32129 20H15.3213V8H5.32429ZM9.32129 6H17.3213V16H19.3213V4H9.32129V6Z",
    fill: "#B08C3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClone);
export default __webpack_public_path__ + "static/media/clone.721ff786d2449d11683e63dd9d5c268b.svg";
export { ForwardRef as ReactComponent };